// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__THJGB","obliqueLineWrap":"membershipbadge_obliqueLineWrap__bgBM2","obliqueLine":"membershipbadge_obliqueLine__162yk"};